import React from "react";
import styled from "@emotion/styled";
import { CheckboxProps } from "react-aria-components";
import { StyledCheckbox, StyledLabel } from "atom/checkbox/checkboxComponents";
import { Checkbox as Cb } from "react-aria-components";

interface MyCheckboxProps extends Omit<CheckboxProps, "children"> {
  children?: React.ReactNode;
  value: string;
}

const StyledCb = styled(Cb)`
  /* Ensure the visually hidden input is anchored and doesn't cause scroll */
  position: relative;
`;

export default function Checkbox({ children, ...props }: MyCheckboxProps) {
  return (
    <StyledCb {...props}>
      <StyledLabel>
        <div className="checkbox" aria-hidden="true">
          <StyledCheckbox className="checkbox-item" />
        </div>
        {children}
      </StyledLabel>
    </StyledCb>
  );
}
